// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"42":"0aefbe24","280":"bbfed173","341":"1f8deb34","736":"b336e1b0","783":"6cba0454","923":"c489027b"}[chunkId] + ".chunk.css";
};